export default __webpack_public_path__ + "static/media/Reedinkite.6f3161c0.webp";